import React, { ReactNode, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersMap } from '@wix/bex-core';
import { InfiniteScrollTableState } from '../../state';
import { CollectionTableContentCard } from './CollectionTableContentCard';

export interface CollectionTableContentBaseProps {
  children?: ReactNode;
}

export interface CollectionTableContentProps<T, F extends FiltersMap>
  extends CollectionTableContentBaseProps {
  state: InfiniteScrollTableState<T, F>;
}

function _CollectionTableContent<T, F extends FiltersMap = FiltersMap>(
  props: CollectionTableContentProps<T, F>,
) {
  const { state: tableState, children } = props;

  const state = tableState.toolbar;

  const {
    showInitialLoader,
    showEmptyState,
    multi: { showRefreshLoader, showErrorState },
    internalScroll,
  } = state;

  const showTableContent =
    !showInitialLoader &&
    !showRefreshLoader &&
    !showErrorState &&
    (!internalScroll || !showEmptyState);

  const [onFullRenderEnd] = useState(() =>
    state.fedopsReporter.onFullRenderStart(),
  );

  useEffect(() => {
    if (showTableContent) {
      onFullRenderEnd();
    }
  }, [showTableContent]);

  return (
    <>
      {showTableContent && (
        // wrapping with Card is WSR way to make the sticky table header not to add extra border between the header and the content https://www.docs.wixdesignsystem.com/?path=/story/components-lists-table--table#Sticky_Toolbar_&_Sub-toolbar
        <CollectionTableContentCard>{children}</CollectionTableContentCard>
      )}
    </>
  );
}

export const CollectionTableContent = observer(_CollectionTableContent);
